module.exports = __webpack_public_path__ + "img/search-empty-state-attachments.114c9d57.svg";